<template>
  <div>
    <v-btn small depressed @click="editProductDetail">{{ $t('edit') }}</v-btn>
    <v-dialog scrollable v-model="show" persistent max-height="1000">
      <v-card v-if="show">
        <v-card-text style="max-height: 600px">
          <v-layout wrap>
            <v-flex xs12 sm6 md4>
              <div class="z-border-red pa-2 mb-2">
                <template v-for="(detail, index) in details">
                  <v-layout :key="'detail_' + index">
                    <v-flex>
                      <v-img aspect-ratio="1" :src="detail.photourl" max-width="50"></v-img>
                    </v-flex>
                    <v-flex class="py-2 pl-1">{{ detail.name }}</v-flex>
                    <v-flex class="py-2">{{ detail.option }}</v-flex>
                    <v-flex class="py-1 form-control">
                      <input
                        type="number"
                        v-model="detail.quantity"
                        class="mb-0"
                        style="max-width: 60px"
                      />
                    </v-flex>
                    <v-flex shrink
                      ><v-btn small fab depressed @click="deleteDetail(index)"
                        ><v-icon>delete</v-icon></v-btn
                      ></v-flex
                    >
                  </v-layout>
                  <v-divider :key="'divider_' + index" v-if="index != details.length - 1" />
                </template>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md8>
              <div class="text-xs-right form-control">
                <input type="text" v-model="search" style="max-width: 300px" placeholder="Search" />
              </div>
              <v-layout wrap>
                <template v-for="product in filterProduct">
                  <v-flex xs6 sm4 md3 lg2 class="pa-1" :key="product.id">
                    <v-card style="height: 100%">
                      <v-img :src="product.photourl" :aspect-ratio="1"></v-img>
                      <v-card-text>
                        {{ product.name }}
                      </v-card-text>
                      <v-divider></v-divider>
                      <div style="height: 100px; overflow: auto">
                        <div v-for="stock in product.productstock" :key="stock[0]">
                          <v-layout>
                            <v-flex class="pa-1">{{ stock[1] }}</v-flex>
                            <v-flex shrink>
                              <v-btn
                                color="primary"
                                small
                                fab
                                depressed
                                class="extra-small"
                                @click="selectProduct(product, stock)"
                                style=""
                                ><v-icon>add</v-icon></v-btn
                              >
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                    </v-card>
                  </v-flex>
                </template>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" outline @click="cancelDetail">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="saveDetail">{{ $t('Save') }}</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="showProduct" persistent>
      <v-card>
        <v-layout>
          <v-flex class="form-control pa-2"> </v-flex>
          <v-flex class="text-xs-right">
            <v-btn small fab flat @click="showProduct = false"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>

        <v-card-text style="max-height: 600px"> </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar color="success" v-model="snackbar" top :timeout="2000">
      Added!!
      <v-btn flat @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: ['value'],
  data() {
    return {
      show: false,
      details: [],
      showProduct: false,
      search: '',
      snackbar: false
    }
  },
  computed: {
    ...mapGetters({
      products: 'getProducts'
    }),
    filterProduct() {
      if (!this.products) return []
      let products = this.products.filter((el) => {
        return ['464', '62'].includes(el.categoryid.toString())
      })

      if (this.search && this.search.trim() != '') {
        products = products.filter((el) => {
          return el.name && el.name.toLowerCase().includes(this.search.trim().toLowerCase())
        })
      }

      return products
    }
  },
  methods: {
    editProductDetail() {
      this.details = cloneDeep(this.value)
      this.show = true
    },
    cancelDetail() {
      this.details = cloneDeep(this.value)
      this.show = false
    },
    saveDetail() {
      this.$emit('input', this.details)
      this.$emit('saveProductDetail', this.details)
      this.show = false
    },
    selectProduct(product, stock) {
      var index_detail = this.details.findIndex((el) => {
        return el.name == product.name && stock[1] == el.option
      })

      if (index_detail != -1) {
        this.$set(this.details[index_detail], 'quantity', this.details[index_detail].quantity + 1)
      } else {
        this.details.push({
          name: product.name,
          option: stock[1],
          photourl: product.photourl,
          quantity: 1
        })
      }
      this.snackbar = true
      // this.showProduct = false
    },
    deleteDetail(index) {
      this.details.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/EditProductDetail.vue